import { useMissionsTranslation } from '../../../../../../ui/hooks';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Button, Typography } from '@mui/material';
import React from 'react';
export const TableRowActions = ({ participantStatus, handleApprove, handleDeny, disableActions = false, }) => {
    const { t } = useMissionsTranslation();
    if (participantStatus === 'deniedRosterFull') {
        return (React.createElement(Typography, { variant: 'body2', sx: { color: (theme) => theme.palette.grey['500'] } }, t('missions.participantStatuses.deniedRosterFull')));
    }
    if (participantStatus === 'deniedNotQualified') {
        return (React.createElement(Typography, { variant: 'body2', sx: { color: (theme) => theme.palette.grey['500'] } }, t('missions.participantStatuses.deniedNotQualified')));
    }
    else {
        return (React.createElement(Box, { display: 'flex', sx: {
                gap: 1,
                flexDirection: { xs: 'column-reverse', sm: 'row' },
                justifyContent: { xs: 'flex-start', md: 'flex-end' },
                flexGrow: { xs: 1, sm: 0 },
            } },
            React.createElement(Button, { variant: 'outlined', startIcon: React.createElement(CloseIcon, null), "data-test": 'deny-button', disabled: disableActions, onClick: (event) => {
                    event.stopPropagation();
                    handleDeny();
                } }, t('common.deny')),
            React.createElement(Button, { variant: 'contained', startIcon: React.createElement(CheckIcon, null), disabled: disableActions, "data-test": 'approve-button', onClick: (event) => {
                    event.stopPropagation();
                    handleApprove();
                } }, t('common.approve'))));
    }
};
